module.exports = __webpack_public_path__ + "img/medal_loser.77cf0c6d.svg";